import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "timeLogInvoice",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    invDocDeleteStatus: false,
  },
  reducers: {
    timeLogInvocieReceived: (timeLogInvoice, action) => {
      timeLogInvoice.list = action.payload;
    },
    taskDone: (timeLogInvoice, action) => {
      timeLogInvoice.loading = false;
    },
    ruleAppDataReceived: (timeLogInvoice, action) => {
      timeLogInvoice.ruleAppData = action.payload;
    },
    timeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.invDocDeleteStatus = action.payload;
    },
  },
});

export const {
  timeLogInvocieReceived,
  taskDone,
  ruleAppDataReceived,
  timeLogInvDocDeleted,
} = slice.actions;
export default slice.reducer;

export const loadTimeLogInvoice = (id) =>
  apiCallBegan({
    url: config.GetTimeLogInvoice + id,
    onSuccess: timeLogInvocieReceived.type,
  });

export const deleteTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: timeLogInvDocDeleted.type,
  });

export const getTimeLogInvoice = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.list,
);

export const getTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.invDocDeleteStatus,
);
